import { FC, useState } from "react";
import CustomLink from "@Components/CustomLink";

import { MenuItemProps } from "./types";
import classes from "./mobileheader.module.scss";
import Chevron from "@Icons/Chevron";
import formatClassNames from "@Utils/clientUtils/stringUtility/formatClassNames";
import useTranslationHook from "hooks/useTranslationHook";
import wrapperHOC from "@Utils/wrapperHOC";

const MenuItem: FC<MenuItemProps> = ({
  label,
  icon,
  redirectTo,
  children,
  clickHandler,
  rightSection = "",
  isDesktop = false,
  addLangPrefixToUrl = false,
  isQuickChat = false,
  showFullRightSection = false,
}) => {
  const [isDescriptionOpen, setisDescriptionOpen] = useState(false);
  const { t } = useTranslationHook();
  return redirectTo ? (
    <CustomLink
      href={redirectTo}
      target="_blank"
      rel="noreferrer"
      isExternal={!addLangPrefixToUrl}
      className={formatClassNames(classes.option, isDesktop && classes.desktop)}
      onClick={clickHandler}
      dataTestId={label}
    >
      <div className={classes.optionLabel}>
        {icon && <>{icon}</>}
        <div className={classes.label}>{t(label)}</div>
      </div>
      {rightSection && (
        <div
          className={formatClassNames(
            classes.pill,
            label === "Shortlist" && classes.pillTransparent,
          )}
          dangerouslySetInnerHTML={{ __html: rightSection }}
        />
      )}
    </CustomLink>
  ) : (
    <>
      <div
        data-testid={label}
        className={formatClassNames(classes.option, isDesktop && classes.desktop)}
        onClick={() => {
          if (clickHandler) clickHandler();
          setisDescriptionOpen((prev) => !prev);
        }}
        role="button"
        tabIndex={0}
        onKeyDown={(event) => {
          if (event.key === "Enter") {
            if (clickHandler) clickHandler();
            setisDescriptionOpen((prev) => !prev);
          }
        }}
      >
        <div className={classes.optionLabel}>
          {icon && <>{icon}</>}
          <div className={classes.label}>{t(label)}</div>
        </div>
        {rightSection && (
          <div
            className={formatClassNames(
              !isQuickChat && classes.pill,
              label === "Shortlist" && classes.pillTransparent,
              showFullRightSection && classes.fullWidthPill,
            )}
            dangerouslySetInnerHTML={{ __html: rightSection }}
          />
        )}
        {children && (
          <div
            className={
              isDescriptionOpen
                ? formatClassNames(classes.chevron, classes.active)
                : classes.chevron
            }
          >
            <Chevron />
          </div>
        )}
      </div>
      {isDescriptionOpen && <div className={classes.menuInnerContainer}> {children}</div>}
    </>
  );
};

export default wrapperHOC(MenuItem, {
  componentName: "MenuItem-Header",
  showForChina: true,
});
